module.exports = __webpack_public_path__ + "img/culture_img2.5c6b3344.png";